import styled from 'styled-components';
import {dFlexBetween} from '../../../../globalVariables/GlobalFlex';

export * from '../transactionCommon.css';

export const addressRow = styled.div`
    ${dFlexBetween}
    gap: var(--space-sm);
`;
